import { render, staticRenderFns } from "./NotificacionesActuacion.vue?vue&type=template&id=1f2328af&scoped=true"
import script from "./NotificacionesActuacion.vue?vue&type=script&lang=js"
export * from "./NotificacionesActuacion.vue?vue&type=script&lang=js"
import style0 from "./NotificacionesActuacion.vue?vue&type=style&index=0&id=1f2328af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2328af",
  null
  
)

export default component.exports